import { TopRightContainer, CourseContainer } from './UserHomeStyles.styles';
import {
  AdminContainer,
  LeftAdmin,
  RightAdmin,
} from '../../AdminRoutes/Admin/AdminStyles.styles';
import UserHomeDataProvider from '../../Utils/Users/UserHomeDataProvider';
import React, { Suspense, useState, useCallback } from 'react';
import { AuthCheckUser } from '../../Utils/AuthCheck/UserCheck.auth';
import Auth from '../../Helpers/auth';
import UserRouterComponent from './UserRouterComponent.component';
import { CSSTransition } from 'react-transition-group';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
const UserMenu = React.lazy(() => import('./UserMenuComponent.component'));
const TabButton = React.lazy(
  () => import('../../Components/Buttons/TabButton/TabButton.component')
);
import EntityLoader from '../../Components/LoadingPages/LoadingEntity.component';
import { useMediaQuery } from 'react-responsive';

const UserHome = () => {
  const { data } = Auth.getProfile();
  const [chosen, setChosen] = useState('AllCourses');

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const handleAllCourses = useCallback((e) => {
    e.preventDefault();
    setChosen('AllCourses');
  }, []);

  const handleIncompleteCourses = useCallback((e) => {
    e.preventDefault();
    setChosen('IncompleteCourses');
  }, []);

  const handleCompleteCourses = useCallback((e) => {
    e.preventDefault();
    setChosen('CompleteCourses');
  }, []);

  return (
    <AuthCheckUser>
      <HelmetHelper title="Home" description="Home page for a user account" />
      <UserHomeDataProvider>
        {(user) => {
          const coursesToDisplay =
            chosen === 'AllCourses'
              ? user?.allCourses
              : chosen === 'IncompleteCourses'
                ? user?.incompleteCourses
                : user?.completeCourses;

          return (
            <AdminContainer>
              <LeftAdmin>
                <Suspense fallback={<div>Loading Menu...</div>}>
                  <UserMenu data={data} user={user} />
                </Suspense>
              </LeftAdmin>
              {!isMobile && (
                <RightAdmin>
                  <TopRightContainer>
                    <Suspense fallback={<div>Loading Tabs...</div>}>
                      <TabButton
                        span="All Courses"
                        functionName={handleAllCourses}
                        active={chosen === 'AllCourses'}
                      />
                      <TabButton
                        span="Incomplete Courses"
                        functionName={handleIncompleteCourses}
                        active={chosen === 'IncompleteCourses'}
                      />
                      <TabButton
                        span="Complete Courses"
                        functionName={handleCompleteCourses}
                        active={chosen === 'CompleteCourses'}
                      />
                    </Suspense>
                  </TopRightContainer>

                  {/* Display Courses */}
                  <CSSTransition
                    in={
                      chosen === 'AllCourses' ||
                      chosen === 'IncompleteCourses' ||
                      chosen === 'CompleteCourses'
                    }
                    timeout={300}
                    classNames="fade"
                    unmountOnExit
                  >
                    <CourseContainer>
                      <Suspense fallback={<EntityLoader />}>
                        <UserRouterComponent
                          courses={coursesToDisplay}
                          user={user}
                          chosen={chosen}
                        />
                      </Suspense>
                    </CourseContainer>
                  </CSSTransition>
                </RightAdmin>
              )}
            </AdminContainer>
          );
        }}
      </UserHomeDataProvider>
    </AuthCheckUser>
  );
};

export default UserHome;
